import React from 'react'
import { IconButton, Box, Typography } from '@mui/material';
import { MdModeEdit } from 'react-icons/md';

function NotifyField({ text, label, onEditHandler }) {
  return (
    <Box
      style={{
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        sx={{ flexGrow: 1 }}
        style={{ marginBottom: 0, textAlign: 'left' }}
      >
        <strong>{label}</strong>
        {text}
      </Typography>
      <IconButton onClick={onEditHandler} data-cypress-name={`edit-${label.toLowerCase().replace(':', '').trim()}`}>
        <MdModeEdit />
      </IconButton>
    </Box>
  );
}

export default NotifyField